<script setup lang="ts">
  import { Button, ButtonAppearance, ButtonSize, Toast, ToastSize, ToastType } from '@travelata-libs/ui-kit';
  import { useTimeoutFn } from '@vueuse/core';
  import { onMounted, watch } from 'vue';
  import { SERP_FILTERS_RESET_TOAST_DURATION_MS } from '../config/filters';
  import { SERP_FILTERS_RESET_TEXTS } from '../config/texts';

  interface SerpFiltersResetToastProps {
    title?: string;
    description: string;
  }

  const props = defineProps<SerpFiltersResetToastProps>();

  interface SerpFiltersResetToastEmits {
    (e: 'restore'): void;
    (e: 'close'): void;
  }

  const emit = defineEmits<SerpFiltersResetToastEmits>();

  const onRestore = (): void => {
    emit('restore');
  };

  const onClose = (): void => {
    emit('close');
  };

  const { start: startAutoClose } = useTimeoutFn(onClose, SERP_FILTERS_RESET_TOAST_DURATION_MS, { immediate: false });

  onMounted(startAutoClose);

  watch(() => [props.title, props.description], startAutoClose);
</script>

<template>
  <div
    class="serp-filters-reset-toast"
    data-testid="serp-filters-reset-toast"
  >
    <Toast
      class="serp-filters-reset-toast__toast"
      :type="ToastType.ImportantInfo"
      :size="ToastSize.M"
      :mobile="true"
      :closable="true"
      :title="title"
      :description="description"
      @close="onClose"
    >
      <template #footer>
        <Button
          :appearance="ButtonAppearance.Tertiary"
          :size="ButtonSize.S"
          data-testid="serp-filters-reset-toast-restore"
          @click="onRestore"
        >
          {{ SERP_FILTERS_RESET_TEXTS.restore }}
        </Button>
      </template>
    </Toast>
  </div>
</template>

<style scoped lang="scss">
  .serp-filters-reset-toast {
    bottom: calc(var(--spacing-m) + env(safe-area-inset-bottom, 0px));
    left: var(--spacing-xs);
    position: fixed;
    right: var(--spacing-xs);
    z-index: 4;

    &__toast {
      box-shadow: var(--shadow-m);
    }
  }
</style>
